import { Container, Content, Wrapper, Button } from '@/styles/pages/terms';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

const TermsCool = () => (
  <>
    <Head>
      <title>Termos Legais</title>
    </Head>

    <Wrapper>
      <div className="hero-1">
        <h1>Termos Legais</h1>
      </div>
    </Wrapper>

    <Container>
      <Content>
        <Link href="/br/termos-de-servico">
          <Button>Termos e Condições Gerais de Serviço </Button>
        </Link>
        <Link href="/br/privacidade-de-dados">
          <Button>Privacidade e Segurança de Dados</Button>
        </Link>
        <Link href="/br/politica-de-cookies">
          <Button>Política de Cookies</Button>
        </Link>
      </Content>
    </Container>
  </>
);

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context;

  if (locale !== 'br') {
    return {
      notFound: true
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(locale.toString()))
    }
  };
};

export default TermsCool;
